// extracted by mini-css-extract-plugin
export default {"root":"ItemQuantity_root__g17sn","button":"ItemQuantity_button__gQd2w","disabled":"ItemQuantity_disabled__GDAA8","amount":"ItemQuantity_amount__Lzg4x"};